export function scaleLayersForMobile(map, layers) {
    if (window.innerWidth >= 750) return;

    layers.forEach(layer => {
        const { id, type, layout, paint } = layer;

        if (type === 'symbol') {
            if (layout?.['icon-size']) {
                map.setLayoutProperty(id, 'icon-size', layout['icon-size'] * 0.7);
            }
            if (layout?.['text-size']) {
                map.setLayoutProperty(id, 'text-size', layout['text-size'] * 0.8);
            }
        }

        if (type === 'circle' && paint?.['circle-radius']) {
            map.setPaintProperty(id, 'circle-radius', paint['circle-radius'] * 0.6);
        }

        if (type === 'line' && paint?.['line-width']) {
            map.setPaintProperty(id, 'line-width', paint['line-width'] * 0.6);
        }
    });
}